module.exports = __webpack_public_path__ + "static/img/guide_1.c4d67d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/newvcr/guide_1.png
// module id = MEEM
// module chunks = 36